export default {
  data() {
    return {
      isLoading: false,
      customLoadingText: 'Loading',
      customLoadingIcon: 'el-icon-loading',
      customLoadingBg: ''
    }
  },
  methods: {
    // 静态资源基础路径拼接
    staticUrl(url) {
      return this.$staticUrl + url
    },
    // 时间格式化
    formatDatetime(date, fmt = 'yyyy-MM-dd HH:mm:ss') {
      var regex1 = /^(\d{4})(-|\/)(\d{1,2})(-|\/)(\d{1,2})$/
      var regex2 = /^(\d{4})(-|\/)(\d{1,2})(-|\/)(\d{1,2}) (\d{1,2}):(\d{1,2}):(\d{1,2})$/
      if (typeof date === 'string' && !regex1.test(date) && !regex2.test(date)) return date
      date = date.toString().replace(/-+/g, '/')
      date = new Date(date)
      var ret
      const opt = {
        // 年
        'y+': date.getFullYear().toString(),
        // 月
        'M+': (date.getMonth() + 1).toString(),
        // 日
        'd+': date.getDate().toString(),
        // 时
        'H+': date.getHours().toString(),
        // 分
        'm+': date.getMinutes().toString(),
        // 秒
        's+': date.getSeconds().toString()
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      }
      for (var k in opt) {
        ret = new RegExp('(' + k + ')').exec(fmt)
        if (ret) {
          fmt = fmt.replace(ret[1], ret[1].length === 1 ? opt[k] : opt[k].padStart(ret[1].length, '0'))
        }
      }
      return fmt
    },
    // 计算时间
    calcTime(date, value, type = 'd', fmt = 'yyyy-MM-dd HH:mm:ss') {
      var regex1 = /^(\d{4})(-|\/)(\d{1,2})(-|\/)(\d{1,2})$/
      var regex2 = /^(\d{4})(-|\/)(\d{1,2})(-|\/)(\d{1,2}) (\d{1,2}):(\d{1,2}):(\d{1,2})$/
      if (!date || (typeof date === 'string' && !regex1.test(date) && !regex2.test(date))) date = new Date()
      date = date.toString().replace(/-+/g, '/')
      date = new Date(date)
      if (
        type !== 'Y' &&
        type !== 'y' &&
        type !== 'd' &&
        type !== 'D' &&
        type !== 'H' &&
        type !== 'h' &&
        type !== 'M' &&
        type !== 'm' &&
        type !== 'S' &&
        type !== 's'
      ) {
        type = 'd'
      }
      if (!value || isNaN(value)) value = 0
      switch (type) {
        case 'y':
        case 'Y':
          date.setYear(date.getYear() + value)
          break
        case 'M':
          date.setMonth(date.getMonth() + value)
          break
        case 'd':
        case 'D':
          date.setDate(date.getDate() + value)
          break
        case 'h':
        case 'H':
          date.setTime(date.getTime() + 1000 * 3600 * value)
          break
        case 'm':
          date.setTime(date.getTime() + 1000 * 60 * value)
          break
        case 's':
        case 'S':
          date.setTime(date.getTime() + 1000 * value)
          break
      }
      var ret
      const opt = {
        // 年
        'y+': date.getFullYear().toString(),
        // 月
        'M+': (date.getMonth() + 1).toString(),
        // 日
        'd+': date.getDate().toString(),
        // 时
        'H+': date.getHours().toString(),
        // 分
        'm+': date.getMinutes().toString(),
        // 秒
        's+': date.getSeconds().toString()
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      }
      for (var k in opt) {
        ret = new RegExp('(' + k + ')').exec(fmt)
        if (ret) {
          fmt = fmt.replace(ret[1], ret[1].length === 1 ? opt[k] : opt[k].padStart(ret[1].length, '0'))
        }
      }
      return fmt
    },
    // 获取树结构所有父级
    getTreePathByKey(currkey, data, keyName = 'id', onself = true) {
      var res = []
      var traverse = (currkey, path, data) => {
        // 树为空时，不执行函数
        if (data.length === 0) return
        // 遍历存放树的数组
        for (const item of data) {
          if (onself) path.push(item)
          // 如果目的节点的id值等于当前遍历元素的节点id值
          if (item[keyName] === currkey) {
            // 把获取到的节点路径数组path赋值到result数组
            res = JSON.parse(JSON.stringify(path))
            return
          }
          if (!onself) path.push(item)
          // 当前元素的children是数组
          const children = Array.isArray(item.children) ? item.children : []
          // 递归遍历子数组内容
          traverse(currkey, path, children)
          // 利用回溯思想，当没有在当前叶树找到目的节点，依次删除存入到的path数组路径
          path.pop()
        }
      }
      traverse(currkey, [], data)
      // 返回找到的树节点路径
      return res
    },
    // 查找路由
    getTreeItem(currkey, data, keyName = 'id', childrenKey = 'children') {
      if (!data || data.length < 1) return undefined
      for (let i = 0; i < data.length; i++) {
        const el = data[i]
        if (el[keyName] === currkey) {
          return JSON.parse(JSON.stringify(el))
        } else if (el[childrenKey] && el[childrenKey].length > 0) {
          var res = this.getTreeItem(currkey, el[childrenKey], keyName, childrenKey)
          if (res) return res
        }
      }
    },
    /**
     * 装载时间
     * @param { beginTime: '', endTime: '', page: 1} params
     * @param {*} dateRange 日期范围数组
     * @param {*} fieldName 字段名
     * @returns
     **/
    joinTime(params, dateRange, fieldName) {
      params = typeof params === 'object' && params !== null && !Array.isArray(params) ? params : {}
      dateRange = Array.isArray(dateRange) ? dateRange : []
      if (typeof fieldName === 'undefined') {
        params['beginTime'] = undefined
        params['endTime'] = undefined
        if (dateRange.length > 0) params['beginTime'] = dateRange[0]
        if (dateRange.length > 1) params['endTime'] = dateRange[1]
      } else {
        params['begin' + fieldName] = undefined
        params['end' + fieldName] = undefined
        if (dateRange.length > 0) params['begin' + fieldName] = dateRange[0]
        if (dateRange.length > 1) params['end' + fieldName] = dateRange[1]
      }
      return params
    },
    // 添加ali图片头
    joinHead(url) {
      let host = 'https://cbu01.alicdn.com/'
      if (process.env.NODE_ENV === 'development' && url) {
        const url2 = url.replace(/^https?:\/\/localhost:\d{0,4}\//, '')
        if (url2 !== url) {
          url = url2
          host = 'http://192.168.0.198:1994/'
        }
      }

      if (!url || url.length < 1 || url.indexOf('http://') >= 0 || url.indexOf('https://') >= 0) {
        return url
      }

      return host + url
    },
    // 币种转化
    currencyConver(currency) {
      switch (currency) {
        default:
        case 'USD':
          return '$'
        case 'CNY':
          return '￥'
      }
    },

    hasAuthority(val) {
      if (this.$store.state.user.isDefault) {
        return true
      }
      val = val || ''
      val = val.toString()
      return this.$store.state.user.authoritys.includes(val)
    }
  }
}
